import { render, staticRenderFns } from "./Mt5DetailsAllTabs.vue?vue&type=template&id=134a88e2"
import script from "./Mt5DetailsAllTabs.vue?vue&type=script&lang=js"
export * from "./Mt5DetailsAllTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports